<template>
    <LayoutMaster>
      <div v-if="isDone">
        <PopularMovies :popular-movies="popularMovies"></PopularMovies>
        <NowPlayingMovie :now-playing-movies="nowPlayingMovies"></NowPlayingMovie>
      </div>
      <div  v-else>
        <div class="flex justify-center items-center min-h-screen pb-28 lg:pb-16">
          <img src="../assets/loading.gif" alt="loading" class="w-80">
        </div>
      </div>
    </LayoutMaster>
</template>

<script>

import LayoutMaster from "@/components/LayoutMaster";
import PopularMovies from "@/components/PopularMovies";
import axios from "axios";
import NowPlayingMovie from "@/components/NowPlayingMovie";
export default {
  name: 'HomeView',
  components: {NowPlayingMovie, PopularMovies, LayoutMaster},
  data() {
    return {
      popularMovies: [],
      nowPlayingMovies: [],
      isDone: false,
    }
  },
  created() {
    let token= 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5Y2Q5ZDIzMWMyZWNmOWVlMjMwNTQ1MjY2MDA0NGU1YSIsInN1YiI6IjYyYWMxOGNiZDdjZDA2MDA5Mjk5ZTNiYSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.8aPeoTYZyUOuN72OyZbXh7gDcw6-RhwVJ4vIedUaeFo';
    axios.get(`https://api.themoviedb.org/3/movie/popular`,{
     headers: {"Authorization" : `Bearer ${token}`}
    })
    .then(res => this.popularMovies = res.data.results)
    .catch(error => console.log(error));

    axios.get(`https://api.themoviedb.org/3/movie/now_playing`,{
      headers: {"Authorization" : `Bearer ${token}`}
    })
   .then(res => this.nowPlayingMovies = res.data.results)
    .catch(error => console.log(error));

    setTimeout(() => {
      this.isDone = true;
    }, 2000);

  }
}
</script>

<style scoped>

</style>